import * as React from 'react';
import { Helmet } from 'react-helmet-async';

const Page = React.forwardRef(({ children, title = 'faces2hire', meta, ...other }, ref) => (
   <>
      <Helmet>
         <title>{title}</title>
         {meta}
      </Helmet>

      <div ref={ref} {...other}>
         {children}
      </div>
   </>
));

export default Page;
